import React__default, { forwardRef } from 'react';
import { useIsMobile, TaktIdProvider, createStormTaktId, Flex } from '@amzn/storm-ui';
import { W as Wrapper, I as InlineError } from '../PageHeader.styles-DKUNRW-4.js';

const AttributesContainer = /*#__PURE__*/forwardRef(({
  children,
  errorMessage,
  taktId,
  taktValue
}, ref) => {
  const isMobile = useIsMobile();
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('page-header-attributes-container')
  }, /*#__PURE__*/React__default.createElement(Wrapper, {
    direction: "column",
    ref: ref
  }, /*#__PURE__*/React__default.createElement(Flex, {
    alignItems: "center",
    wrap: "wrap",
    columnGap: isMobile ? 'small' : 'base',
    rowGap: isMobile ? 'small' : 'base'
  }, children), !!errorMessage && /*#__PURE__*/React__default.createElement(InlineError, {
    message: errorMessage,
    variant: "error"
  })));
});

export { AttributesContainer as A };
//# sourceMappingURL=AttributesContainer-Ct1akiB4.js.map
